import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import "../css/navbar.css";
import logo from "../image/logo.png";
import { fetchCategories, fetchSubCategories } from "../store/action";
import { useSearchParams } from "react-router-dom";
import NavbarHeader from "./NavbarHeader";

export default function NavBar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { categories, subCategories } = useSelector(state => state.categoryReducer);

  useEffect(() => {
    dispatch(fetchCategories());
    dispatch(fetchSubCategories());
  }, []);

  const handlefilter = (subCatId) => {
    if (searchParams.get('cat') == subCatId) return;
    navigate(`/?cat=${subCatId}`);
  }

  const handleResetFilter = () => {
    navigate('/');
  }

  return (
    <nav className="navbar-sticky">
      <NavbarHeader />
      <div className="container">
        <NavLink to="/" id="navLogo">
          <img src={logo} />
        </NavLink>
        <ul className="list-unstyled mb-0 d-flex">
          <li className="nav-item">
            <a onClick={() => handleResetFilter()}>All</a>
          </li>
          {
            categories.map(category => {
              return (
                <li className="nav-item" key={'nav-category-' + category.id}>
                  <a>{category.name}</a>
                  <div className="dropdown-nav">
                    {
                      subCategories.filter(x => +x.CategoryId === +category.id).map((v, i) => {
                        return (
                          <a className="d-block" key={category.name + '-' + i} onClick={() => handlefilter(v.id)}>{v.name}</a>
                        )
                      })
                    }
                  </div>
                </li>
              )
            })
          }
        </ul>
      </div>
    </nav>
  )
}